export const config: any = {
  floatLabelOptions : ['auto', 'always', 'never'],
  floatLabel: ''
};
config.floatLabel = config.floatLabelOptions[0];
